import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operationDays'
})
export class OperationDaysPipe implements PipeTransform {

  transform(value: string): string {
    const valorInicial: string = value;
    let valorFinal = '';
    let i = 0;

    for (i = 1; i < 8; i++) {
      const posicion: number = valorInicial.indexOf(i.toString());
      if (posicion !== -1) {
        valorFinal = valorFinal + i.toString();
        } else {
          valorFinal = valorFinal + '0';
      }
    }
    return valorFinal;
  }

}
